function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { EyeOffIcon } from '@heroicons/react/outline';
import { EyeIcon } from '@heroicons/react/solid';
import classNames from 'classnames';
import React, { useState, useMemo } from 'react';
import TextInput from '../TextInput/TextInput';
const PasswordInput = /*#__PURE__*/React.forwardRef(({
  label,
  value,
  hasError,
  inputClassName,
  labelClassName,
  ...prop
}, ref) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const handlePasswordVisibility = () => {
    setPasswordVisible(!isPasswordVisible);
  };
  const inputType = useMemo(() => isPasswordVisible ? 'text' : 'password', [isPasswordVisible]);
  const borderClassNames = classNames('border', 'border-x-0', 'border-t-0', 'border-b-1', 'border-gray-300', 'w-7', 'inline-flex', 'peer-focus:border-kira-blue-300', `${inputClassName ?? ''}`);
  return /*#__PURE__*/React.createElement(TextInput, _extends({
    label: label,
    value: value
  }, prop, {
    labelClassName: labelClassName,
    type: inputType,
    hasError: hasError,
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    className: borderClassNames
  }, isPasswordVisible ? /*#__PURE__*/React.createElement(EyeIcon, {
    "data-testid": "eye-icon",
    className: "text-slate-400",
    onClick: handlePasswordVisibility
  }) : /*#__PURE__*/React.createElement(EyeOffIcon, {
    "data-testid": "eye-off-icon",
    className: "text-slate-400",
    onClick: handlePasswordVisibility
  })));
});
export default PasswordInput;